<template>
  <div :id="id" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" :class="extraClass" v-if="value">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button class="btn green" @click.prevent="save" data-style="expand-left">Save</button>
            <button class="btn default" data-dismiss="modal" aria-hidden="true">Cancel</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    extraClass: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['save', 'input'],
  methods: {
    save() {
      this.$emit('save');
      $(`#${this.id}`).modal('hide');
    }
  },
  mounted () {
    $(`#${this.id}`).on('show.bs.modal', () => {
      this.$emit('shown');
    }).on('hidden.bs.modal', () => {
      this.$emit('input', false);
    });
  },
  watch: {
    value (value) {
      if (value) {
        $(`#${this.id}`).modal('show')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BaseModal.vue?ed2d8172